'use client'

import { useTranslations } from 'next-intl'

import { Button } from '../../../../components/Button'

interface Props {
  onClick?: () => void
}

// TODO: implement functionality when the backend is there
export function WithdrawButton({ onClick }: Props) {
  const translate = useTranslations('product-details')

  return (
    <Button variant="outline" onClick={onClick} className="w-full">
      {translate('withdraw-button')}
    </Button>
  )
}
